import { SET_EMP_LISTDATA } from "../actions";

const emplistdata = (state = [], action) => {
  switch (action.type) {
    case SET_EMP_LISTDATA:
      return [...action.value];
    default:
      return state;
  }
};

export default emplistdata;
